const REMEMBER_ME_KEY = "drumlog_remember_me";
const SUPABASE_KEY_PREFIX = "sb-";

function getSupabaseKeys(storage: Storage): string[] {
  const keys: string[] = [];
  for (let i = 0; i < storage.length; i++) {
    const key = storage.key(i);
    if (key && key.startsWith(SUPABASE_KEY_PREFIX)) {
      keys.push(key);
    }
  }
  return keys;
}

class StorageAdapter {
  constructor() {
    // Legacy handling: existing users with Supabase keys in localStorage
    // but no remember_me flag → treat as "remember me = true"
    const flag = localStorage.getItem(REMEMBER_ME_KEY);
    if (flag === null && getSupabaseKeys(localStorage).length > 0) {
      localStorage.setItem(REMEMBER_ME_KEY, "true");
    }
  }

  private get active(): Storage {
    return localStorage.getItem(REMEMBER_ME_KEY) === "true"
      ? localStorage
      : sessionStorage;
  }

  getItem(key: string): string | null {
    return this.active.getItem(key);
  }

  setItem(key: string, value: string): void {
    this.active.setItem(key, value);
  }

  removeItem(key: string): void {
    this.active.removeItem(key);
  }

  /** Call before signInWithPassword to set the storage target. */
  setRememberMe(value: boolean): void {
    const oldStorage = this.active;
    localStorage.setItem(REMEMBER_ME_KEY, value ? "true" : "false");
    const newStorage = this.active;

    if (oldStorage === newStorage) return;

    // Migrate existing Supabase keys to the new storage
    for (const key of getSupabaseKeys(oldStorage)) {
      const val = oldStorage.getItem(key);
      if (val !== null) {
        newStorage.setItem(key, val);
      }
      oldStorage.removeItem(key);
    }
  }

  /** Call on signOut to clean both storages. */
  clearAll(): void {
    for (const key of getSupabaseKeys(localStorage)) {
      localStorage.removeItem(key);
    }
    for (const key of getSupabaseKeys(sessionStorage)) {
      sessionStorage.removeItem(key);
    }
    localStorage.removeItem(REMEMBER_ME_KEY);
  }
}

export const storageAdapter = new StorageAdapter();
